import { getFormedEltTranslation } from './getFormedEltTranslation'

export const actualTranslationKey = getFormedEltTranslation('financial-table-actual')
const forecastQuarterTranslationKey = getFormedEltTranslation('financial-table-forecast-quarter')

export const forecastQuarterTranslationKeyShort = getFormedEltTranslation(
  'financial-table-forecast-quarter-short'
)

interface IGetQuarterStateTranslationKey {
  quarter: 1 | 2 | 3 | 4
  currentQuarter: number
  shortView?: boolean
  year: number
  currentYear: number
}

const isActualQuarter = ({
  quarter,
  currentQuarter,
  currentYear,
  year,
}: IGetQuarterStateTranslationKey) => {
  if (year < currentYear) {
    return true
  }
  return quarter < currentQuarter
}

export const getQuarterStateTranslationKey = ({
  quarter,
  currentQuarter,
  year,
  currentYear,
  shortView = false,
}: IGetQuarterStateTranslationKey) => {
  // if (currentYear < yearFromJbpSettings) {
  //   return actualTranslationKey
  // }
  const actualQuarter = isActualQuarter({ quarter, currentQuarter, currentYear, year })
  if (shortView) {
    return actualQuarter ? '' : forecastQuarterTranslationKeyShort
  }
  return actualQuarter ? actualTranslationKey : forecastQuarterTranslationKey
}
